import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Camera } from "iconsax-react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import type { CreateShopLogoUploadProps } from "./CreateShopLogoUpload.types";
import * as styles from "./CreateShopLogoUpload.styles";

export function CreateShopLogoUpload({ logoPreview, onLogoSelect }: CreateShopLogoUploadProps) {
  const { t } = useTranslation("shops");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Box sx={styles.root}>
      <Box
        component="button"
        type="button"
        sx={styles.button}
        onClick={() => inputRef.current?.click()}
      >
        {logoPreview ? (
          <Box component="img" src={logoPreview} alt="" sx={styles.image} />
        ) : (
          <Camera
            size={isDesktop ? 30 : 26}
            variant="Bold"
            color={theme.palette.text.secondary}
          />
        )}
      </Box>

      <Box component="span" sx={styles.hint}>
        {t(isDesktop ? "create.info.logoHint" : "create.info.logoHintMobile")}
      </Box>

      <Box
        component="input"
        ref={inputRef}
        type="file"
        accept="image/*"
        sx={styles.hidden}
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) onLogoSelect(file);
        }}
      />
    </Box>
  );
}
